import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { isDesktopScreen } from '../HelperFunctions';
import { getAxisData, getKetrometaryDiopterData, getPositiveNegativeData } from './inputdropdown/dataCalchelper';
import { connect } from 'react-redux';

function InputDropdown(props) {
  const { input, disabled, placeholder, wrapperClasses, className, label, readOnly, nextFocusRef, data, textField, valueField, meta: { touched, error, active }, dropdownClasses, additionalValues, leftPosition, onChangeHook, cylinderFormat } = props;
  const [isActive, setIsActive] = useState(false);
  const [dataArr, setDataArr] = useState([]);
  const myRef = useRef(null);
  const isDesktopScreenView = isDesktopScreen();

  useEffect(() => {
    setDataArr(formatDataToDisplay(data));
  }, []);

  useEffect(() => {
    setIsActive(active)
  }, [active])

  function formatDataToDisplay(data) {
    let negatives = [], positives = [], nonNumeric = [];
    data.forEach(item => {
      const value = parseFloat(item.key);
      if (isNaN(value)) {
        nonNumeric.push(item);
      } else if (value < 0) {
        negatives.push(item);
      } else {
        positives.push(item);
      }
    });
    negatives.sort((a, b) => parseFloat(b.key) - parseFloat(a.key));
    positives.sort((a, b) => parseFloat(a.key) - parseFloat(b.key));
    let finalValue = [[...negatives], [...nonNumeric, ...positives]].filter(arr => arr.length);

    if (input.name.includes('axis]')) {
      if (input.name.includes('keratometry_attributes')) {
        nonNumeric.shift()
        finalValue = getAxisData([...nonNumeric, ...positives])
      }
      else {
        finalValue = getAxisData([...positives])
      }
    }
    else if (input.name.includes('keratometry_attributes')) {
      if (input.name.includes('diopter]')) {
        finalValue = getKetrometaryDiopterData(data, 'diopter')
      } else if (input.name.includes('mm]')) {
        finalValue = getKetrometaryDiopterData(data, 'mm')
      }
    }
    else {
      finalValue = getPositiveNegativeData(finalValue, additionalValues)
      if (input.name.includes('_add]')) {
        let arr = [...finalValue[0]]
        arr[0] = [finalValue[1][0], finalValue[0][0]].flat()
        finalValue = [arr]
      }
      else if (input.name.includes('_sphere]')) {
        finalValue[0][0] = [{ key: '0.00' }, ...finalValue[0][0]]
        finalValue[2][0] = [{ key: '0.00' }, ...finalValue[2][0]]
      }
    }
    return finalValue;
  }

  useEffect(() => {
    if (isActive) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isActive]);

  const handleOutsideClick = (e) => {
    if (myRef.current && !myRef.current.contains(e.target)) {
      setIsActive(false);
    }
  };

  const handleFocus = () => {
    setIsActive(true);
  };

  const handleBlur = (e) => {
    if (!myRef.current.contains(e.relatedTarget)) {
      setIsActive(false);
    }
  };

  const handleValueSelect = (value) => {
    input.onChange(value);
    onChangeHook && onChangeHook(value)
    setIsActive(false);
    if (input.name.includes('_cylinder]') && (value == 'DS' || value == ' ')) {
      return ''
    }
    else {
      nextFocusRef?.ref.current.handleFocus()
    }
  };

  const handleOnChange = (e) => {
    onChangeHook && onChangeHook(e.target.value)
    input.onChange(e.target.value);
  }

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses} position-relative d-flex flex-column`} ref={myRef}>
      {label && <label>{label}</label>}
      <input
        {...input}
        value={input.value}
        autoComplete="off"
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        onChange={handleOnChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`${className} ${touched && error && 'is-invalid'} form-control pl-4`}
      />
      {isActive &&
        <>
          <div className={`${dropdownClasses} width-1-half height-1-half border border-bottom-0 border-right-0 rotate-45 position-absolute z-index-3 bg-white ${label ? 'input-dropdown' : 'mt-9'}`}></div>
          <RenderDropdown
            handleValueSelect={handleValueSelect}
            valueField={valueField}
            cylinderFormat={cylinderFormat}
            textField={textField}
            inputValue={input.value}
            error={error}
            touched={touched}
            leftPosition={leftPosition}
            inputName={input.name}
            dataArr={dataArr}
            isDesktopScreenView={isDesktopScreenView}
          />
        </>
      }
    </div>
  );
}

const RenderDropdown = (props) => {
  const { handleValueSelect, textField, valueField, inputValue, error, touched, leftPosition, inputName, dataArr, isDesktopScreenView, cylinderFormat } = props

  const getLeftAlignVal = () => {
    const [mainField, subField, lasField] = inputName.split('[');
    const isLeftAlignedField = ['subjective_attributes', 'cycloplegic_attributes', 'current_glasses_attributes'].includes(mainField);
    if (isLeftAlignedField) {
      const lasFieldSuffix = lasField?.split('_')?.[1];
      const subFieldSuffix = subField?.split('_')?.[1];
      if ((['subjective_attributes', 'cycloplegic_attributes'].includes(mainField) && subFieldSuffix !== "add]") || subFieldSuffix === 'axis]' || mainField === 'current_glasses_attributes' && lasFieldSuffix !== "add]") {
        if (subFieldSuffix === 'axis]' || lasFieldSuffix === 'axis]') {
          return '-43rem';
        }
        if (subFieldSuffix === 'cylinder]' || lasFieldSuffix === 'cylinder]') {
          return '-2rem';
        }
        return '-41rem';
      }
    }
    return leftPosition ?? (subField.includes('axis') ? '-12.8rem' : '-0.8rem');
  };

  const getLeftAlignValTabView = () => {
    const isKetromateryVerticalVal = inputName.search('vertical')
    if (isKetromateryVerticalVal && isKetromateryVerticalVal !== -1) {
      return '-37rem'
    }
    return '-0.8rem'
  }

  const renderAxis = () => {
    const labels = ["1-60", "61-120", "121-180"];
    return (
      <div className='d-flex flex-row overflow-auto'>
        {dataArr?.map((arr, arrIdx) => {
          return <span className={`p-2 my-2 overflow-auto ${!isDesktopScreenView && 'width-22'} ${arrIdx === 1 ? 'bg-light mx-4' : 'bg-primary-light'}`} style={{ width: '25.6rem' }} key={`arr-${arrIdx}`}>
            {arrIdx === 0 ?
              <div className='d-flex justify-content-between'>
                <button tabIndex="-1" className={`border border-1 input-dropdown-style pb-6 width-4 height-1-half ${arrIdx !== 0 && 'bg-primary-light'} ${' ' === inputValue ? 'bg-primary text-white' : `bg-white`}`} key={`empty_str`} onClick={() => handleValueSelect(' ')}>
                  <span className='invisible'>hide</span>
                  {/* {(item[textField] == ' ' || !item[textField]) ? <span className='invisible'>hide</span> : ' '} */}
                </button>
                <h6 className='text-primary pb-2 text-center'>{labels[arrIdx]}</h6>
                <span></span>
              </div> :
              <h6 className='text-primary pb-2 text-center'>{labels[arrIdx]}</h6>
            }
            {arr.map((item, index) => <button tabIndex="-1" className={`border border-1 input-dropdown-style pb-6 width-4 height-1-half ${arrIdx !== 0 && 'bg-primary-light'} ${item[valueField] === inputValue ? 'bg-primary text-white' : `${arrIdx === 1 ? 'bg-white' : 'bg-light'}`}`} key={`${item[valueField]}-${index}`} onClick={() => handleValueSelect(item[valueField])}>{(item[textField] == ' ' || !item[textField]) ? <span className='invisible'>hide</span> : item[textField]}</button>)}
          </span>
        })}
      </div>
    )
  }

  const renderLensPrescription = () => {
    const labels = (cylinderFormat == 'negative' && inputName.includes('cylinder]')) ? ["", "(-)"] : ["(+)", "", "(-)"];

    const getClasses = (arrLength, index) => {
      let classes = '';
      if (inputName.includes('sphere]')) {
        classes = `${index === 0 && 'flex-row-reverse'}`
      }
      else if (inputName.includes('add]') || inputName.includes('cylinder]')) {
        if (inputName.includes('cylinder]')) {
          classes = `${index === 0 && 'flex-row-reverse'}`
        }
        return `${arrLength === 1 ? '' : 'justify-content-end align-items-end'} ${classes}`
      }
      return `${classes}`
    }

    const getStyles = () => {
      if (inputName.includes('sphere]')) {
        return { width: '43rem' };
      }
      else if (inputName.includes('cylinder]')) {
        return { width: '17.3rem' };
      }
      else if (inputName.includes('add]')) {
        return { width: '17.3rem' };
      }
      return {};
    };

    return (
      <div className="d-flex justify-content-start overflow-auto">
        {dataArr?.map((arr, arrIdx) => (
          <span
            key={`arr-${arrIdx}`}
            className={`p-2 ${arr.length === 1 ? 'width-5' : ''} flex-wrap my-2 d-flex ${getClasses(arr.length, arrIdx)} ${arrIdx === 1 ? "mx-4 bg-light" : "bg-primary-light"}`}
            style={getStyles()}
          >
            {labels[arrIdx] && <h6 className='text-primary pb-2 text-center w-100'>{labels[arrIdx]}</h6>}
            {arr.map((itemArr, index) => {
              return (
                <span className={`d-flex flex-column mb-5`} key={`internal-arr-${index}`}>
                  {labels[arrIdx] === '' && <h6 className='text-primary pb-2 text-center w-100'>{inputName.includes('od') ? 'OD' : 'OS'}</h6>}
                  {itemArr.map((item, index) => (
                    <button
                      tabIndex="-1"
                      key={`${item.key}-${index}`}
                      onClick={() => handleValueSelect(item.key)}
                      className={`border border-1 input-dropdown-style pb-6 width-4 height-1-half
                ${item.key === inputValue ? "bg-primary text-white" : arrIdx === 1 ? "bg-white" : "bg-light"}`}
                    >
                      {item.key === " " || !item.key ? (
                        <span className="invisible">hide</span>
                      ) : (
                        item.key
                      )}
                    </button>
                  ))}
                </span>
              )
            })}
          </span>
        ))}
      </div>
    );
  };

  const renderKeratometry = () => {
    const labels = inputName.includes('mm]') ? ["14.67-7.35", "7.33-4.82"] : ["23-46", "46-74"];
    return (
      <div className="d-flex flex-row overflow-auto">
        {dataArr?.map((arr, arrIdx) => (
          <span
            key={`arr-${arrIdx}`}
            className={`p-2 flex-wrap justify-content-center my-2 d-flex ${arrIdx === 1 ? "mx-4 bg-light" : "bg-primary-light"}`}
          >
            <h6 className='text-primary pb-2 text-center'>{labels[arrIdx]}</h6>
            {arr.map((itemArr, index) => {
              return (
                <span className={`d-flex align-items-start mb-5`} key={`internal-${index}`}>
                  {itemArr.map((itemArr2, index) => {
                    return (
                      <span className={`d-flex flex-wrap width-22`} key={`internal-arr2-${index}`}>
                        {itemArr2.map((item) => (
                          <button
                            tabIndex="-1"
                            key={`${item}-${index}`}
                            onClick={() => handleValueSelect(item)}
                            className={`border border-1 input-dropdown-style pb-6 width-4 height-1-half
                ${item == inputValue ? "bg-primary text-white" : arrIdx === 1 ? "bg-white" : "bg-light"}`}
                          >
                            {item === " " || !item ? (
                              <span className="invisible">hide</span>
                            ) : (
                              item
                            )}
                          </button>
                        ))}
                      </span>
                    )
                  })}
                </span>
              )
            })}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className="dropdown-menu show position-absolute border d-flex z-index-2 p-3 overflow-auto hidden-scroll"
      style={{ left: isDesktopScreenView ? getLeftAlignVal() : getLeftAlignValTabView() }}
    >
      <div className='d-flex flex-column'>
        {touched && error && <div className='text-danger p-2'>* {error}</div>}
        {inputName.includes('axis]') ?
          renderAxis() :
          inputName.includes('keratometry_attributes') ? renderKeratometry() : renderLensPrescription()
        }
        <p className='text-primary font-size-14 text-center mb-0'><i className="las la-info-circle mr-2"></i>For higher values, type in.</p>
      </div>
    </div>
  )
};

const mapStateToProps = (state) => {
  const { setting: { orgConfig } } = state
  return {
    cylinderFormat: orgConfig.org_config?.exam_settings?.cylinder_format,
  }
}

export default connect(mapStateToProps)(InputDropdown);